<div class="pull-right text-muted">
  <a ng-click = "activeHistoryRecommendations()">
    <i class="icon-updated" aria-hidden="true"></i> Histórico
  </a>
</div>
<div class="clearfix"></div>

<div class="title text-center">
  <h2 class="f-size-22">
    <strong ng-show="recommendation.id">EDITANDO RECOMENDAÇÃO #{{recommendation.id}}</strong>
    <strong ng-hide="recommendation.id">NOVA RECOMENDAÇÃO</strong>
  </h2>
</div>

<form id="recomendacao_form" name="recomendacao_form" novalidate blur-on-submit ng-submit="save(recomendacao_form, recommendation.id)">
  <p class="text-center margin text-cinza" ng-show="loading">
    <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando...
  </p>
  <div class="recomendacao" ng-hide="loading">

    <!-- safra -->
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': recomendacao_form.safra.$invalid}">
        <ui-select ng-model="recommendation.safra" ng-change="changeSafra()" theme="bootstrap" id="safra" name="safra" required ng-disabled="!canEdit()">
          <ui-select-match allow-clear="canEdit()" placeholder="Safra">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="safra in safras | orderBy: '-descricao' | filter: $select.search">
            <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
        <p class="help-block" ng-show="recomendacao_form.safra.$dirty && recomendacao_form.safra.$error.required">Informe a safra</p>
      </div>
    </div>

    <!-- glebas -->
    <div class="width-100">
      <div class="form-group no-margin">
        <ui-select ng-model="gleba.selected" on-select="addGleba($item)" theme="bootstrap" id="glebas" name="glebas" ng-disabled="!canEdit()">
          <ui-select-match allow-clear="true" placeholder="Talhões">{{$select.selected.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="gleba in glebasAtividade | orderBy: 'descricao' | filter: $select.search | filter: {selected: false}">
            <span ng-bind-html="gleba.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="width-100" ui-sortable="sortableRecommendations" ng-model="glebasAtividade">
      <div class="form-group m-b-none m-t-xs" ng-repeat="gleba in glebasAtividade track by $index" ng-show="gleba.selected">
        <div class="input-group width-90 pull-left">
          <span class="input-group-addon no-padding width-50">
            <a ng-click="showApplicationsHistory(gleba)">
              <span uib-tooltip="{{gleba.descricao | capitalize}}" tooltip-append-to-body="true">
                {{gleba.descricao | capitalize | characters:12}}
              </span>
              <span ng-hide="loadingSpraysGleba == gleba.id" uib-tooltip="Histórico de Aplicações" tooltip-append-to-body="true">
                <i class="icon-info" aria-hidden="true"></i>
              </span>
              <span ng-show="loadingSpraysGleba == gleba.id">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </a>
          </span>
          <input class="form-control p-xxs" placeholder="Área" ng-model="gleba.area" type="number" auto-step ng-change="changeGlebasAndProdutos()" ng-disabled="!canEdit()">
          <span class="input-group-addon p-xxs">ha</span>
        </div>
        <span type="button" class="btn width-10 pull-right p-xxs" ng-click="removeGleba(gleba)" ng-if="canEdit()">
          <i class="fa fa-times fa-lg" aria-hidden="true"></i>
        </span>
      </div>
      <div class="clearfix"></div>
    </div>

    <div class="width-100">
      <h5 class="total-gleba pull-right">
        Total: {{recommendation.glebas.areaTotal || 0 | number:2}} ha
      </h5>
    </div>

    <div class="clearfix"></div>
    <br>

    <!-- produtos -->
    <div class="width-100 products">
      <div class="form-group no-margin">
        <ui-select ng-model="produto.selected" on-select="addProduto($item)" theme="bootstrap" id="produtos" name="produtos" ng-disabled="!canEdit()">
          <ui-select-match allow-clear="canEdit()" placeholder="Pesquisar produto">{{$select.selected.descricao}}</ui-select-match>
          <ui-select-choices repeat="produto in produtos" refresh="searchProdutos($select)" refresh-delay="300">
            <div ng-bind-html="produto.descricao | highlight: $select.search"></div>
            <span ng-show="$root.permissions.estoque.canViewStock && $root.parametros.tem_controle_de_estoque">
              <small ng-bind-html="'Físico: ' + (produto.saldo_fisico | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
              <small ng-bind-html="'A Receber: ' + (produto.saldo_receber | number:4) + ' ' + (produto.unidade.abreviatura)"></small><br>
              <small ng-bind-html="'Em Uso: ' + (produto.saldo_em_uso | number:4) + ' ' + (produto.unidade.abreviatura)"></small>
            </span>
          </ui-select-choices>
        </ui-select>
        <small class="help-block" ng-show="searchProduto.length && !loadingProdutos && !produtos">
          Informe pelo menos 3 caracteres
        </small>
        <span class="input-group-addon no-border no-background" ng-show="loadingProdutos">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
        <span class="input-group-addon no-border no-background" ng-show="!loadingProdutos && produtos.length === 0">
          Não encontrado
        </span>
      </div>
      <button type="button" class="btn btn-white" title="Ver todos os produtos" ng-click="openProductModal()">
        <i class="fa fa-external-link"></i>
      </button>
    </div>
    <div class="width-100" ui-sortable="sortableRecommendations" ng-model="recommendation.produtos">
      <div class="form-group m-b-none m-t-xs padding-top-5" ng-repeat="produto in recommendation.produtos track by $index">
        <div class="produto-group-addon padding-left-3">
          <p class="no-margin">
            <b>{{(produto.produto || produto).descricao | characters:30}}</b>
          </p>
  
          <div class="width-90 inline-flex">
            <input
              ng-if="!isDecimalV2Enabled"
              class="form-control p-xxs"
              placeholder="Dose"
              ng-change="changeDose(produto)"
              ng-model="produto.dose"
              fixed-decimal-input
              type="text"
              inputmode="decimal"
              ng-disabled="!canEdit()"
              ng-blur="fixDose(produto)">
            <input
              ng-if="isDecimalV2Enabled"
              class="form-control p-xxs"
              placeholder="Dose"
              ng-focus="startEditDose(produto)"
              ng-blur="fixDose(produto)"
              ng-model="produto.dose"
              fixed-decimal-input
              type="text"
              inputmode="decimal"
              ng-disabled="!canEdit()">

            <div class="input-group-btn width-50" uib-dropdown dropdown-append-to-body>
              <button type="button" class="btn btn-secondary width-100 padding-6" uib-dropdown-toggle>
                {{produto.unidadeSelected.nomeAbreviado || 'Unid.'}}
                <span class="caret"></span>
              </button>
              <ul class="dropdown-menu-right" uib-dropdown-menu>
                <li class="dropdown-item" ng-repeat="unidade in produto.unidades">
                  <a href="#" ng-click="setUnidadeProduto($event, produto, unidade)">{{unidade.nomeAbreviado}}</a>
                </li>
              </ul>
            </div>
  
            <input
              ng-if="!isDecimalV2Enabled"
              title="Total"
              class="form-control p-xxs"
              placeholder="Total"
              ng-model="produto.qtTotal"
              fixed-decimal-input="milhar"
              type="text"
              inputmode="decimal"
              ng-change="changeQuantidadeTotal(produto)"
              ng-disabled="!canEdit() || quantidadeTotalBloqueada"
              ng-blur="fixQuantidadeTotal(produto)">
            <input
              ng-if="isDecimalV2Enabled"
              title="Total"
              class="form-control p-xxs"
              placeholder="Total"
              ng-focus="startEditQuantidadeTotal(produto)"
              ng-model="produto.qtTotal"
              fixed-decimal-input="milhar"
              type="text"
              inputmode="decimal"
              ng-blur="fixQuantidadeTotal(produto)"
              ng-disabled="!canEdit() || quantidadeTotalBloqueada">
          </div>
          <span type="button" class="btn width-10 pull-right p-xxs" ng-click="removeProduto($index)" ng-if="canEdit()">
            <i class="fa fa-times fa-lg" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="area-produto clearfix" ng-if="recommendation.produtos.length > 0">
      <h6>
        <span>em <b>{{recommendation.glebas.areaTotal || 0| number:2}} ha</b></span>
      </h6>
    </div>

    <div class="clearfix"></div>
    <br>

    <!-- data inicio -->
    <div class="width-100">
      <div class="form-group margin-data-inicial" ng-class="{'has-error': recomendacao_form.data_inicial.$invalid}">
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Iniciar em"
            uib-datepicker-popup="{{popupData.format}}" ng-model="recommendation.dataInicial"
            is-open="popupData.openedDataInicial" show-button-bar="false" datepicker-append-to-body="true"
            ng-change="changeData('inicial')" id="data_inicial" name="data_inicial" required ng-disabled="!canEdit()">
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="openPopupData('openedDataInicial')" ng-disabled="!canEdit()">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
        <p class="help-block" ng-show="recomendacao_form.data_inicial.$dirty && recomendacao_form.data_inicial.$error.required">Informe a data inicial</p>
      </div>
    </div>

    <!-- data termino -->
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': recomendacao_form.data_final.$invalid}">
        <div class="input-group">
          <input type="text" class="form-control" readonly datepicker-options="datePickerOptions" placeholder="Finalizar em "
            uib-datepicker-popup="{{popupData.format}}" ng-model="recommendation.dataFinal"
            is-open="popupData.openedDataFinal" show-button-bar="false"  datepicker-append-to-body="true"
            ng-change="changeData('final')" id="data_final" name="data_final" required ng-disabled="!canEdit()">
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="openPopupData('openedDataFinal')" ng-disabled="!canEdit()">
              <i class="glyphicon glyphicon-calendar"></i>
            </button>
          </span>
        </div>
        <p class="help-block" ng-show="recomendacao_form.data_final.$dirty && recomendacao_form.data_final.$error.required">Informe a data final</p>
      </div>
    </div>

    <!-- responsável -->
    <div class="width-100">
      <div class="form-group" ng-class="{'has-error': recomendacao_form.responsavel.$invalid}">
        <div class="input-group width-100">
          <span class="input-group-addon width-35 p-xxs" ng-if="recommendation.responsavel">Responsável</span>
          <ui-select ng-model="recommendation.responsavel" theme="bootstrap" id="responsavel" name="responsavel" required ng-disabled="!canEdit()">
            <ui-select-match allow-clear="canEdit()" placeholder="Responsável">{{$select.selected.nome_completo | capitalize | characters:30}}</ui-select-match>
            <ui-select-choices repeat="usuario in users | orderBy: 'nome_completo' | filter: $select.search">
              <span class="form-group" ng-bind-html="usuario.nome_completo | capitalize | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
        <p class="help-block" ng-show="recomendacao_form.responsavel.$dirty && recomendacao_form.responsavel.$error.required">Informe o Responsável</p>
      </div>
    </div>

    <!-- vento -->
    <div class="width-100">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-addon width-20 p-xxs">Vento</span>
          <input class="form-control" placeholder="Vento" ng-model="recommendation.vento.maxima" type="number" id="vento" name="vento" ng-disabled="!canEdit()">
          <span class="input-group-addon">km/h</span>
        </div>
      </div>
    </div>

    <!-- velocidade -->
    <div class="width-100">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-addon width-20 p-xxs">Vel.</span>
          <input class="form-control p-xxs" placeholder="mínima" ng-model="recommendation.velocidade.minima" type="number" id="velocidade_minima" name="velocidade_minima" ng-disabled="!canEdit()">
          <span class="input-group-addon p-xxs">até</span>
          <input class="form-control p-xxs" placeholder="máxima" ng-model="recommendation.velocidade.maxima" type="number" id="velocidade_maxima" name="velocidade_maxima" ng-disabled="!canEdit()">
        </div>
      </div>
    </div>

    <!-- observação -->
    <div class="width-100">
      <div class="form-group">
        <textarea class="form-control" placeholder="Observações" ng-model="recommendation.observacao" id="observacao" name="observacao" ng-disabled="!canEdit()"></textarea>
      </div>
    </div>

    <div class="m-t-sm m-b-sm" ng-if="recommendation.id">
      <historico-alteracoes id="{{recommendation.id}}" type="AqilaRecomendacao" />
    </div>

    <div class="btn-group btn-group-justified">
      <div class="btn-group">
        <button class="btn btn-primary padding-5" type="submit"
                ng-disabled="recomendacao_form.$invalid || loadingSave || loadingDelete || loadingReject || !canEdit()">
          Salvar
          <span ng-show="loadingSave">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
      <div class="btn-group" ng-if="recommendation.id">
        <button class="btn btn-danger padding-5" type="button" ng-click="delete()"
                ng-disabled="loadingSave || loadingDelete || loadingReject">
          Excluir
          <span ng-show="loadingDelete">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
      <div class="btn-group" ng-if="recommendation.id">
        <button class="btn btn-default padding-5" type="button" ng-click="duplicate()"
                ng-disabled="loadingSave || loadingDelete || loadingReject">
          Duplicar
        </button>
      </div>
    </div>
  </div>
</form>
